import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum"
import { projectBasePathName, projectShowPath } from "@/ts/apiRoutes";

export const useProjectShowStore = defineStore('project-show', () => {
    const project = ref<object>([])

    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    async function getProjectInfo(id: number) {
        status.value = RequestStatus.LOADING

        const response = await request(`${projectBasePathName}/${id}${projectShowPath}`, {
            method: 'GET'
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS
            project.value = await response.json()
        }

        return response
    }

    return { project, status, getProjectInfo }
})